import React, { useState, useEffect } from 'react';
import './App.css';
import defaultMintIcon from './default-mint-icon.svg';
import zeusLogo from './zeus-logo.svg';
import nutLogo from './nut-logo.svg';

function App() {
  const [status, setStatus] = useState({ connected: {}, error: [] });
  const [loading, setLoading] = useState(true);
  const [fetchError, setFetchError] = useState(null);
  const [copiedUrl, setCopiedUrl] = useState(null);

  const handleCopyUrl = (url) => {
    navigator.clipboard.writeText(url);
    setCopiedUrl(url);
    setTimeout(() => {
      setCopiedUrl(null);
    }, 2000);
  };

  const setFallbackImage = (e) => {
    e.target.onerror = null;
    e.target.src = defaultMintIcon;
    e.target.classList.add('default-image-bg');
  };

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        // Using a cors proxy for development if you run into CORS issues.
        // const response = await fetch('https://cors-anywhere.herokuapp.com/https://zeuspay.com/api/lnurl/mints');
        const response = await fetch('https://zeuspay.com/api/lnurl/mints');
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setStatus(data);
      } catch (error) {
        setFetchError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchStatus();
  }, []);

  return (
    <div className="App">
      <header className="App-header">
        <img src={zeusLogo} className="header-icon zeus-logo" alt="Zeus logo" />
        <img src={nutLogo} className="header-icon nut-logo" alt="Nut logo" />
      </header>
      <main>
        {loading && <p>Loading...</p>}
        {fetchError && <p>Error fetching status: {fetchError}</p>}
        {!loading && !fetchError && (
          <>
            <div className="mints-section">
              <h2>Connected Mints</h2>
              <div className="mints-list">
                {Object.keys(status.connected).length > 0 ? (
                  Object.entries(status.connected).map(([url, mint]) => (
                    <div key={url} className={`mint-item ${copiedUrl === url ? 'copied' : ''}`} onClick={() => handleCopyUrl(url)}>
                      {copiedUrl === url ? (
                        <p>URL copied to clipboard!</p>
                      ) : (
                        <>
                          <img src={mint.image || defaultMintIcon} onError={setFallbackImage} alt={mint.name} className={!mint.image ? 'mint-image default-image-bg' : 'mint-image'} />
                          <div className="mint-info">
                            <p>{mint.name}</p>
                            <p className="mint-url">{url}</p>
                          </div>
                        </>
                      )}
                    </div>
                  ))
                ) : (
                  <p>No connected mints.</p>
                )}
              </div>
            </div>
            {status.error.length > 0 && (
              <div className="mints-section">
                <h2>Mints with Errors</h2>
                <ul className="error-list">
                  {status.error.map((errorUrl) => (
                    <li key={errorUrl} className={`error-item ${copiedUrl === errorUrl ? 'copied' : ''}`} onClick={() => handleCopyUrl(errorUrl)}>
                      {copiedUrl === errorUrl ? 'URL copied to clipboard!' : errorUrl}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </>
        )}
      </main>
    </div>
  );
}

export default App;
